import { useEffect, useState } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import VideoComponent from '../../../components/video/video.component';
import { IMAGES_REPO } from '../../../static-resources/home-image-repo';
import {
  VideoDataProps,
  videoData,
} from '../../../static-resources/static-misc';
import AnimatedSectionComponent from '../../about/components/animated-section.component';
import PublishedByComponent from '../../releases/components/publishedBy/publishedBy.component';
import ViewAllCardComponent from './viewallcard.component';
import './trainingvideo.component.scss';

const TABKEY_VIEWALL = 'view-all';
const TABKEY_TRAINING = 'tutorials';
const TABKEY_DEMOS = 'demos';
const TABKEY_RESOURCES = 'resources';
const TABKEY_RELEASENOTES = 'release-notes';
const TABKEY_FAQ = 'faq';

const BREADCRUMBS: Record<string, any> = {
  [TABKEY_VIEWALL]: { title: 'View All' },
  [TABKEY_TRAINING]: { title: 'Training' },
  [TABKEY_DEMOS]: { title: 'Demos' },
  [TABKEY_RESOURCES]: { title: 'Resources' },
  [TABKEY_RELEASENOTES]: { title: 'Release Notes' },
  [TABKEY_FAQ]: { title: 'FAQs' },
};

const TrainingVideoComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    video,
    relatedVideos = [],
  }: { video: VideoDataProps; relatedVideos: VideoDataProps[] } =
    location.state || {};
  const { trainingAndResourcesSection } = useParams();
  const [tabKey, setTabKey] = useState(TABKEY_VIEWALL);

  useEffect(() => {
    if (trainingAndResourcesSection) {
      setTabKey(trainingAndResourcesSection);
    }
  }, [trainingAndResourcesSection]);

  if (!video) {
    return <div>No video data available.</div>;
  }

  const irisVideos = videoData.filter((video) => video.group === 'IRIS');

  const handleViewAllClick = () => {
    navigate('/training/view-all');
  };

  return (
    <>
      <div className="container-fluid">
        <div className="breadcrumb-section container">
          <Breadcrumb className="pt-5 pb-2">
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/training">
              Training and Resources
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              {BREADCRUMBS[tabKey]?.title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div className="container-fluid viewAllCard">
        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <h2 className="video-title">{video.title}</h2>
              <p className="video-description">{video.description}</p>
              <AnimatedSectionComponent top="50px">
                <VideoComponent
                  embedUrl={video.linkSrc ?? ''}
                  title={video.title}
                  banner={IMAGES_REPO.IRISLogoImage}
                />
              </AnimatedSectionComponent>
              <PublishedByComponent videoUrl={video.linkSrc ?? ''} />
            </div>

            <div className="container">
              <h3>Watch Next</h3>
              <p>Here are some more recommendations based on your interests:</p>
              <div className="row">
                {relatedVideos.map((relatedVideo) => (
                  <ViewAllCardComponent
                    {...relatedVideo}
                    key={relatedVideo.title}
                  />
                ))}
              </div>
            </div>
            <div className="container">
              <div className="d-flex justify-content-between align-items-center video-d-flex">
                <h3>IRIS</h3>
                <button
                  className="btn btn-primary view-all-btn"
                  onClick={handleViewAllClick}
                >
                  View All
                </button>
              </div>
              <div className="row">
                {irisVideos.slice(0, 2).map((videoItem) => (
                  <ViewAllCardComponent {...videoItem} key={videoItem.title} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrainingVideoComponent;
